import React, { useRef, useEffect } from 'react';
import './thinking-display.scss';

interface ThinkingDisplayProps {
  thinkingContent: string;
}

const ThinkingDisplay: React.FC<ThinkingDisplayProps> = ({
  thinkingContent,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const displayContent = thinkingContent;

  // Auto-scroll to bottom as new content streams in
  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      requestAnimationFrame(() => {
        el.scrollTop = el.scrollHeight;
      });
    }
  }, [displayContent]);

  return (
    <div className='thinking-display'>
      <div className='thinking-content' ref={contentRef}>
        {displayContent}
      </div>
    </div>
  );
};

export default ThinkingDisplay;
